import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "input"]

  connect() {
    if (this.hasCheckboxTarget && this.inputHasValue() && !this.checkboxTarget.checked) {
      this.checkboxTarget.checked = true
    }
    this.applyState()
  }

  toggle() {
    this.applyState({ focusOnShow: true })
  }

  validate() {
    this.refreshError()
  }

  applyState({ focusOnShow = false } = {}) {
    if (!this.hasCheckboxTarget || !this.hasInputTarget) {
      return
    }

    if (this.checkboxTarget.checked) {
      this.inputTarget.style.display = "block"
      this.inputTarget.setAttribute("required", "required")
      if (focusOnShow) {
        this.inputTarget.focus()
      }
    } else {
      this.inputTarget.style.display = "none"
      this.inputTarget.removeAttribute("required")
      this.inputTarget.value = ""
      this.inputTarget.classList.remove("form-input-error")
    }
  }

  refreshError() {
    if (!this.hasInputTarget) {
      return
    }

    const mandatory = this.inputTarget.hasAttribute("required")
    this.inputTarget.classList.toggle("form-input-error", mandatory && !this.inputHasValue())
  }

  inputHasValue() {
    return this.hasInputTarget && this.inputTarget.value.trim().length > 0
  }
}
